import { useMemo } from 'react';
import { useMedicalCareContext } from '../contexts/MedicalCareContext';
import { useFhirData } from '../utils/useFhirData';
import dayjs from 'dayjs';

interface PatientData {
    name?: string;
    age?: number;
    gender?: string;
    weight?: number;
    height?: number;
    birthDate?: string;
}

export function usePatientData(): PatientData {
    const { summaryData, patient } = useMedicalCareContext();

    return useMemo(() => {
        const patientData: PatientData = {};

        if (patient?.name?.[0]?.text) {
            patientData.name = patient.name[0].text;
        }

        if (patient?.birthDate) {
            patientData.birthDate = patient.birthDate;
            const birthDate = dayjs(patient.birthDate);
            const today = dayjs();
            patientData.age = today.diff(birthDate, 'year');
        }

        if (patient?.gender) {
            patientData.gender = patient.gender;
        }

        if (summaryData) {
            const observationSummary = useFhirData.extractPatientSummaryResource(
                summaryData,
                "Observation"
            )?.[0];

            if (observationSummary?.entry) {
                const weightObservation = observationSummary.entry.find((obs: any) =>
                    obs?.resource?.code?.coding?.[0]?.code === "29463-7" ||
                    obs?.resource?.code?.text === "Peso"
                );

                if (weightObservation?.resource?.valueQuantity?.value) {
                    patientData.weight = weightObservation.resource.valueQuantity.value;
                }

                const heightObservation = observationSummary.entry.find((obs: any) =>
                    obs?.resource?.code?.coding?.[0]?.code === "8302-2" ||
                    obs?.resource?.code?.text === "Altura"
                );

                if (heightObservation?.resource?.valueQuantity?.value) {
                    patientData.height = heightObservation.resource.valueQuantity.value;
                }
            }
        }

        return patientData;
    }, [summaryData, patient]);
}
